export default defineNuxtPlugin(() => {
  document.addEventListener("click", (e) => {
    const link = (e.target as HTMLElement).closest("a");
    if (!link) return;

    const url = link.getAttribute("href");
    const spa = link.getAttribute("target") === "_spa";

    if (spa && url) {
      e.preventDefault();

      if(!url.startsWith("http")){
        useRouter().push(url);
      }

      if (url.startsWith("~")) {
        navigateTo(url.replace('~/', ''));
      }
    }
  });
});
